module.exports = __webpack_public_path__ + "static/img/image_home_product_02.5779880.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/home/image_home_product_02.png
// module id = Epam
// module chunks = 10